import React from 'react';
import { useTrialStatus } from '../../contexts/SubscriptionContext';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/Button';
import './Subscription.css';

export const SubscriptionBanner: React.FC = () => {
  const { isTrial, isNearExpiration, daysRemaining, isExpired } = useTrialStatus();
  const navigate = useNavigate();

  // Só mostra banner se estiver em trial e próximo da expiração, ou se expirou
  if (!isTrial && !isExpired) return null;
  if (isTrial && !isNearExpiration) return null;

  if (isExpired) {
    return (
      <div className="ns-subscription-banner ns-subscription-banner-expired">
        <div className="ns-subscription-banner-content">
          <div>
            <strong>Período de teste expirado</strong>
            <p>Assine agora para continuar usando o NutriSync</p>
          </div>
          <Button onClick={() => navigate('/subscription')}>
            Assinar Agora
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="ns-subscription-banner ns-subscription-banner-warning">
      <div className="ns-subscription-banner-content">
        <div>
          <strong>
            {daysRemaining === 1
              ? 'Último dia do período de teste!'
              : `${daysRemaining} dias restantes no período de teste`}
          </strong>
          <p>Assine agora para continuar usando todas as funcionalidades</p>
        </div>
        <Button onClick={() => navigate('/subscription')}>
          Assinar Agora
        </Button>
      </div>
    </div>
  );
};

